// odometer-api answers 400 with this plain-text body when odometer_at is ahead of the server clock,
// which also happens when the user's computer clock runs fast.
const FUTURE_DATE_MESSAGE = 'Odometer_at must be in the past or present';

type UpstreamError = { body?: unknown };

const bodyOf = (error: UpstreamError) => (typeof error.body === 'string' ? error.body : JSON.stringify(error.body ?? ''));

// GraphQLRequester rejects with `{ errors }` when the mutation returns no data, and the requester
// rethrows `errors[0]` when it does, so both shapes reach the mutation's onError.
export const isOdometerFutureDateError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) return false;

  const errors: unknown[] = Array.isArray((error as { errors?: unknown }).errors) ? (error as { errors: unknown[] }).errors : [error];

  return errors.some((item) => typeof item === 'object' && item !== null && bodyOf(item as UpstreamError).includes(FUTURE_DATE_MESSAGE));
};
